<template>
  <div style="margin-left: 8px">
    Note: This is a number assigned by local govermment agencise to identify a business entity within the local market. For example: the CNPJ in Brazil, the SIRET in France, etc.
  </div>
</template>
<script>
export default {
  name: 'TaxIdDescription'
};
</script>
<style scoped>

</style>
